/* RASO — DA v9 (brouillon) : interactions légères, sans dépendance */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header compact au scroll */
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      root.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Menu mobile : se place sous le header, bloque le scroll de la page */
  const menu = document.querySelector('[data-mobile-menu]');
  const header = document.querySelector('.site-header');
  if (menu && header) {
    const placeMenu = () => {
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      menu.style.setProperty('--menu-top', bottom + 'px');
    };
    new MutationObserver(() => {
      const open = menu.hasAttribute('data-open');
      if (open) placeMenu();
      root.classList.toggle('menu-open', open);
    }).observe(menu, { attributes: true, attributeFilter: ['data-open'] });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && menu.hasAttribute('data-open')) {
        menu.removeAttribute('data-open');
        document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Correctif : après un clic sur une pastille couleur, l'image au survol
     reprenait le dessus et masquait la couleur choisie */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    const secondary = swatch.closest('[data-product-card]')?.querySelector('.product-card__image--secondary');
    if (secondary) secondary.hidden = true;
  });

  /* Petit rebond du compteur panier quand il change */
  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    new MutationObserver(() => {
      count.classList.remove('is-bump');
      void count.offsetWidth;
      count.classList.add('is-bump');
    }).observe(count, { childList: true, characterData: true, subtree: true });
  });

  /* Apparition douce des sections au scroll (pas le hero, pas le header) */
  if (!reduce && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '#MainContent > .shopify-section:not(:first-child) .section-title, ' +
      '#MainContent .product-grid > *, #MainContent .collection-grid > *, ' +
      '#MainContent .ambassador-grid > *, #MainContent .brand-story > div, ' +
      '#MainContent .brand-story aside > div, #MainContent .newsletter-shopify > *'
    );
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach((el) => {
      const siblings = el.parentElement ? Array.from(el.parentElement.children) : [];
      const index = Math.min(siblings.indexOf(el), 6);
      if (index > 0) el.style.transitionDelay = index * 60 + 'ms';
      el.classList.add('r-reveal');
      io.observe(el);
    });
  }
})();

/* =========================================================
   Panier en tiroir, bouton d'achat fixe, filtres
   (lancé après tous les scripts différés : r-sales.js compris)
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const routes = window.Shopify?.routes?.root || '/';

  /* ---------- Tiroir panier ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    let lastFocus = null;
    const panel = () => drawer.querySelector('[data-cart-drawer-panel]');
    const setCount = (count) => document.querySelectorAll('[data-cart-count]').forEach((node) => {
      if (node.textContent.trim() !== String(count)) node.textContent = count;
    });

    const open = () => {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        root.classList.add('drawer-open');
        panel()?.focus({ preventScroll: true });
      });
    };
    const close = () => {
      drawer.classList.remove('is-open');
      root.classList.remove('drawer-open');
      setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 450);
      lastFocus?.focus?.({ preventScroll: true });
    };

    const refresh = async () => {
      const response = await fetch(routes + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('refresh');
      const html = (await response.json())['cart-drawer'];
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-panel]');
      if (fresh) {
        panel().innerHTML = fresh.innerHTML;
        panel().dataset.count = fresh.dataset.count;
        setCount(fresh.dataset.count);
      }
    };

    const change = async (key, quantity) => {
      drawer.classList.add('is-busy');
      try {
        const response = await fetch(routes + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Quantité indisponible.');
        }
        await refresh();
      } catch (error) {
        await refresh().catch(() => {});
        const body = drawer.querySelector('.cart-drawer__body');
        const note = document.createElement('p');
        note.className = 'r-cart-error';
        note.textContent = error.message;
        body?.prepend(note);
      } finally {
        drawer.classList.remove('is-busy');
      }
    };

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-close]')) { close(); return; }
      const line = event.target.closest('[data-cart-line]');
      if (!line) return;
      const current = Number(line.dataset.quantity) || 0;
      const step = event.target.closest('[data-cart-qty]');
      if (step) change(line.dataset.key, Math.max(0, current + Number(step.dataset.cartQty)));
      if (event.target.closest('[data-cart-remove]')) change(line.dataset.key, 0);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const focusables = panel().querySelectorAll('a[href],button:not([disabled]),input,select,textarea');
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    /* Lien PANIER du header -> ouvre le tiroir (clic molette / ctrl gardent la page panier) */
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.header-tools a[href$="/cart"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      if (location.pathname.endsWith('/cart')) return;
      event.preventDefault();
      refresh().catch(() => {}).finally(open);
    });

    /* Ajout rapide des cartes produit : theme.js fait l'ajout puis met le compteur à jour ;
       dès que le compteur change après un ajout rapide, on ouvre le tiroir */
    let pendingQuickAdd = false;
    document.addEventListener('submit', (event) => {
      if (event.target.matches?.('[data-quick-add-form]')) pendingQuickAdd = true;
    }, true);
    document.querySelectorAll('.header-tools [data-cart-count]').forEach((count) => {
      new MutationObserver(() => {
        if (!pendingQuickAdd) return;
        pendingQuickAdd = false;
        refresh().then(open).catch(() => {});
      }).observe(count, { childList: true, characterData: true, subtree: true });
    });

    /* Formulaire principal de la fiche produit : ajout sans quitter la page.
       Les configurateurs, le R. Kit et le kit r-sales gardent leur propre logique. */
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add\/?$/.test(new URL(form.action, location.href).pathname)) return;
      if (form.matches('[data-quick-add-form]') || form.closest('.main-product--configurator, [data-r-kit-dialog], .r-sales-kit')) return;
      if (event.defaultPrevented) return;
      event.preventDefault();
      const button = event.submitter || form.querySelector('[type="submit"]');
      const label = button?.textContent;
      form.querySelector('.r-cart-error')?.remove();
      if (button) { button.disabled = true; button.textContent = 'AJOUT…'; }
      try {
        const response = await fetch(routes + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || 'Ajout impossible.');
        await refresh();
        open();
      } catch (error) {
        const note = document.createElement('p');
        note.className = 'r-cart-error';
        note.setAttribute('role', 'alert');
        note.textContent = error.message;
        (button?.parentElement || form).insertBefore(note, button?.nextSibling || null);
      } finally {
        if (button) { button.disabled = false; button.textContent = label; }
      }
    });
  }

  /* ---------- Bouton d'achat fixe : visible seulement quand le vrai bouton sort de l'écran ---------- */
  const sticky = document.querySelector('.r-sales-sticky');
  const primary = document.querySelector('.main-product:not(.main-product--configurator) .product-form [type="submit"], .rsd__panel form[action*="/cart/add"] [type="submit"]');
  if (sticky && primary && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }).observe(primary);
  } else if (sticky) {
    sticky.classList.add('is-visible');
  }

  /* ---------- Filtres : ouverts s'il y en a d'actifs, appliqués dès qu'on coche ---------- */
  const filterForm = document.getElementById('CollectionFiltersForm');
  if (filterForm) {
    const panelFilters = document.getElementById('CollectionFilters');
    const toggle = document.querySelector('.collection-filter-toggle');
    if (panelFilters && filterForm.querySelector('input[type="checkbox"]:checked')) {
      panelFilters.hidden = false;
      toggle?.setAttribute('aria-expanded', 'true');
    }
    filterForm.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]')) filterForm.requestSubmit();
    });
  }
});
